export default "__VITE_ASSET__CnCLtfhY__";